import axios from "axios";

export const getGrades = async (schoolId) => {
  try {
    const { data } = await axios.get(`/api/v1/grade/school?schoolId=${schoolId}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const addGrade = async ({ name, schoolId, description, createdBy }) => {
  try {
    const { data } = await axios.post('/api/v1/grade', { name, schoolId, description, createdBy } );
    return data;
  } catch (error) {
    throw error;
  }
};

export const editGrade = async ({ id, name, schoolId, description, modifiedBy }) => {
  try {
    const { data } = await axios.patch('/api/v1/grade', { id, name, schoolId, description, modifiedBy } );
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteGrade = async (id) => {
  try {
    const { data } = await axios.delete(`/api/v1/grade?id=${id}`);
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteGrades = async (grade) => {
  try {
    const { data } = await axios.post('/api/v1/grade/school', grade);
    return data;
  } catch (error) {
    throw error;
  }
};

